import * as actions from './actions';
import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';
import apiTracking from '../../utils/tracking/apiTracking';
import * as donationActions from '../Donation/actions';
import * as pollActions from '../Poll/actions';
import * as sentimentPollActions from '../SentimentPoll/actions';
import * as voteRegistrationActions from '../VoteRegistration/actions';
import * as electionReminderActions from '../ElectionReminder/actions';
import * as checkRegistrationActions from '../CheckRegistration/actions';
import * as findPollingStationActions from '../FindPollingStation/actions';
import * as quizActions from '../Quiz/actions';
import * as linkActions from '../Link/actions';
import * as tweetActions from '../Tweet/actions';
import * as callActions from '../Call/actions';
import * as volunteerActions from '../Volunteer/actions';
import * as videoActions from '../Video/actions';

const eventMappings = {};
eventMappings[actions.WIDGET_VISIBLE] = [trackWidgetVisible];
eventMappings[actions.ACTION_VISIBLE] = [trackActionVisible];
eventMappings[actions.WIDGET_ENGAGED] = [trackWidgetEngaged];
eventMappings[actions.ACTION_SHARED] = [trackShareAction];

eventMappings[actions.ACTION_INITIATED_LOCAL_REP] = [trackOpenAction];
eventMappings[donationActions.SELECT_AMOUNT] = [trackOpenAction];
eventMappings[pollActions.POLL_INITIATED] = [trackOpenAction];
eventMappings[voteRegistrationActions.VOTE_REGISTRATION_INITIATED] = [trackOpenAction];
eventMappings[electionReminderActions.ELECTION_REMINDER_INITIATED] = [trackOpenAction];
eventMappings[checkRegistrationActions.CHECK_REGISTRATION_INITIATED] = [trackOpenAction];
eventMappings[findPollingStationActions.FIND_POLLING_STATION_INITIATED] = [trackOpenAction];
eventMappings[quizActions.QUIZ_INITIATED] = [trackOpenAction];
eventMappings[sentimentPollActions.SENTIMENT_POLL_INITIATED] = [trackOpenAction];
eventMappings[linkActions.LINK_INITIATED] = [trackOpenAction];
eventMappings[tweetActions.TWEET_INITIATED] = [trackOpenAction];
eventMappings[callActions.CALL_INITIATED] = [trackOpenAction];
eventMappings[videoActions.VIDEO_INITIATED] = [trackOpenAction];
eventMappings[volunteerActions.VOLUNTEER_INITIATED] = [trackOpenAction];

eventMappings[actions.SUBSCRIBE_SUCCESS] = [trackNewsletterSubscription];

eventMappings[actions.INCREMENT_NO_CARDS_VISITED] = [clearInitiatedActionIdentifiers];

let initiatedActionIdentifiers = [];
const subscriptionActionIdentifiers = [];

export default function trackWidget(type, state) {
    const eventTrackers = eventMappings[type];
    if (eventTrackers != null) {
        eventTrackers.map(f => f(state));
    }
}

function trackWidgetVisible(state) {
    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_WIDGET_VISIBLE, {
        ...state.widget
    });

    apiTracking.trackWidgetVisible(state);

    trackActionVisible(state);
}

function trackWidgetEngaged(state) {
    apiTracking.trackWidgetEngaged(state);
}

function trackActionVisible(state) {
    state.widget.actions
        .filter(a => a.order === state.widget.activeAction.order)
        .forEach(action => {
            sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_SEEN, {
                ...state.widget,
                actions: null,
                action
            });

            apiTracking.trackActionVisible({
                ...state,
                widget: { ...state.widget, activeAction: action }
            });
        });

    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_SEEN, {
        ...state.widget,
        actions: null,
        action: state.widget.activeAction
    });
}

function trackShareAction(state) {
    const sharedWith = state.widget.lastSharedWith;

    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_SHARED, {
        ...state.widget,
        action: state.widget.activeAction,
        sharedWith
    });

    apiTracking.trackSharedAction(state, sharedWith);
}

function trackOpenAction(state) {
    if (
        initiatedActionIdentifiers.find(
            identifier => identifier === state.widget.activeAction.identifier
        )
    ) {
        return;
    }

    initiatedActionIdentifiers.push(state.widget.activeAction.identifier);

    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_INITIATED, {
        ...state.widget,
        action: state.widget.activeAction
    });

    apiTracking.trackOpenAction(state);
}

function trackNewsletterSubscription(state) {
    if (
        subscriptionActionIdentifiers.find(
            identifier => identifier === state.widget.activeAction.identifier
        )
    ) {
        return;
    }

    subscriptionActionIdentifiers.push(state.widget.activeAction.identifier);

    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_NEWSLETTER_SUBSCRIPTION, {
        ...state.widget,
        action: state.widget.activeAction
    });

    apiTracking.trackNewsletterSubscription(state);
}

function clearInitiatedActionIdentifiers() {
    initiatedActionIdentifiers = [];
}



// WEBPACK FOOTER //
// ./src/containers/Widget/tracking.js